/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject } from '@angular/core';
import {
  HttpRequest,
  HttpEvent,
  HttpErrorResponse,
  HttpHandlerFn
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { GlobalFacade } from '~backoffice/app/~store/facades/global.facade';
import {
  SHOW_ERROR_INTERCEPTOR_FOR_401,
  SKIP_ERROR_INTERCEPTOR
} from '~backoffice/app/~shared/constants/global.constants';
import { extractFromRequestData } from '../utils/utils';
import { ToastService } from '../services/toast.service';

export function httpErrorsInterceptor(
  request: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> {
  const globalFacade = inject(GlobalFacade);
  const toastService = inject(ToastService);
  const { request: req, value: useStateFormViolationHandler } =
    extractFromRequestData<boolean>(request, 'useStateFormViolationHandler');

  const { value: skipErrorInterceptor } = extractFromRequestData<boolean>(
    request,
    'skipErrorInterceptor'
  );

  return next(req).pipe(
    tap({
      error: error => {
        if (useStateFormViolationHandler) {
          globalFacade.handleFormViolations(error);
        }
      }
    }),
    catchError((error: HttpErrorResponse) => {
      if (
        request.context.get(SKIP_ERROR_INTERCEPTOR) === true ||
        skipErrorInterceptor
      ) {
        return throwError(() => error);
      }
      if (
        error.status === 401 &&
        request.context.get(SHOW_ERROR_INTERCEPTOR_FOR_401) !== true
      ) {
        return throwError(() => error);
      }

      if (error.error) {
        if (error.status === 0) {
          toastService.open({
            content: `Veuillez vérifier votre accès à internet`,
            type: 'error'
          });
        } else if (!error.error.violations) {
          toastService.open({
            content:
              error.error.detail ||
              error.error.title ||
              `Une erreur s'est produite. Veuillez réessayer plus tard.`,
            type: 'error'
          });
        }
      }

      return throwError(() => error);
    })
  );
}
